import { BaseModel } from '../base.model';

export class questionType extends BaseModel {
  id: number;
  name: string;
  description?: string;

}
